import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { RouteComponentProps, withRouter } from 'react-router';
import { TableCommon } from 'common/components/TableCommon';
import { EBaseOrderDirection, IBaseFilterModel } from 'common/models/requestModels';
import { ERoutesPrivate } from 'common/models/routesModel';
import { objectToQuery, queryToObject } from 'common/helpers/filters.helper';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import {
  getBitecoinRewardCategoryCollection,
  setBitecoinRewardCategoryCollection,
} from 'app/store/reducers/bitecoin.reducer';
import { EBitecoinPageTabKeys } from 'app/pages/Franchisor/BitecoinPage';
import {
  IBitecoinRewardCategoryCollectionFilter,
  IBitecoinRewardCategoryModel,
} from 'entities/Bitecoin/Bitecoin.models';

interface IComponentProps {
  config: ColumnsType<any>;
  filter?: IBitecoinRewardCategoryCollectionFilter;
}

type AllProps = IComponentProps & RouteComponentProps;

const BitecoinRewardCategoryTableComponent: React.FC<AllProps> = ({ filter, config, history }) => {
  const dispatch = useAppDispatch();
  const { bitecoinRewardCategoryCollection, bitecoinRewardCategoryCollectionLoading } = useAppSelector(
    (state) => state.bitecoin
  );

  const loadCollection = (params: IBaseFilterModel) => {
    const filterParams: IBitecoinRewardCategoryCollectionFilter = {
      ...params,
      orderDirection: EBaseOrderDirection.ASC,
    };

    dispatch(getBitecoinRewardCategoryCollection(filterParams));
  };

  const addQuery = (pageIndex: number) => {
    const searchPath = queryToObject({
      tab: EBitecoinPageTabKeys.RewardCategories,
      pageIndex: 1,
    });
    const search = objectToQuery({ ...searchPath, pageIndex });

    return history.replace({ search });
  };

  const onRowClick = (item: IBitecoinRewardCategoryModel) => {
    history.push(`${ERoutesPrivate.BitecoinRewardCategory}/${item.id}`);
  };

  const clearCollection = () => {
    return dispatch(setBitecoinRewardCategoryCollection(null));
  };

  return (
    <TableCommon
      config={config}
      filter={filter}
      collection={bitecoinRewardCategoryCollection}
      loading={bitecoinRewardCategoryCollectionLoading}
      loadCollection={loadCollection}
      clearCollection={clearCollection}
      onRowClick={onRowClick}
      addQuery={addQuery}
    />
  );
};

export const BitecoinRewardCategoryTable = withRouter(BitecoinRewardCategoryTableComponent);
